import CoreMessageDispatcher from '../../controller/CoreMessageDispatcher';
import {SwitchOnAnalyticEvents} from '../elementsControl/SwitchOnAnalyticEvents';
import {SwitchOnShareButtons} from '../elementsControl/SwitchOnShareButtons';
import {SetFormattedDataValue} from '../elementsControl/SetFormattedDataValue';
import CoreEvents from '../../events/CoreEvents';
import ChangeOrders from '../../events/ChangeOrders';

const StartApp = doThat => {
    return new Promise(resolve => {
        if (!doThat) {
            resolve(doThat);
            return;
        }

        SwitchOnShareButtons(doThat)
            .then(SwitchOnAnalyticEvents)
            .then(SetFormattedDataValue)
            .then(doThat => {
                // Switch sound on for browsers that doesn't allow autoplay
                const lr = () => {
                    CoreMessageDispatcher.instance().emit(ChangeOrders.FIRST_USER_ACTION);
                    if (lr) document.removeEventListener('click', lr);
                };

                document.addEventListener('click', lr);

                CoreMessageDispatcher.instance().emit(CoreEvents.READY);
                resolve(doThat);
            });
    });
};

export {StartApp};
